import request, {requestJson} from '../main';
const service = ""
class RulesApi {
    private url: string = service + "/measuring-rules";

    public pageV3(args: any){
        return request({
            url: this.url + '/page-v3',
            method: 'get',
            params: args
        })
    }

    public countShareRules(mode: string){
        return request({
            url: this.url + '/count-share-rules',
            method: 'get',
            params: {
                mode: mode
            }
        })
    }

    public page(args: any){
        return request({
            url: this.url + '/page',
            method: 'get',
            params: args
        })
    }
    public pageCopy(args: any){
        return request({
            url: this.url + '/page-copy',
            method: 'get',
            params: args
        })
    }

    public listRulesCopy(args: any){
        return request({
            url: this.url + '/list-state-measuring-rules-copy',
            method: 'get',
            params: args
        })
    }
    public list(args: any){
        return request({
            url: this.url + '/list-state-measuring-rules',
            method: 'get',
            params: args
        })
    }

    public listStateMeasuringRulesByNum(args: any){
        return request({
            url: this.url + '/list-state-measuring-rules-by-num',
            method: 'get',
            params: args
        })
    }
    public getRules(args: any){
        return request({
            url: this.url + '/get-by-id',
            method: 'get',
            params: args
        })
    }
    //新增或者编辑
    public update(args: any){
        return requestJson({
            url: this.url + '/update',
            method: 'post',
            data: args
        })
    }
    public delete(ids: any){
        return request({
            url: this.url + '/delete',
            method: 'post',
            data: {
                ids: ids
            }
        })
    }
    //查询共享的数量
    public count(releaseStatus: any){
        return request({
            url: this.url + '/count',
            method: 'get',
            params: {releaseStatus: releaseStatus}
        })
    }
    //批量更新发布状态
    public updateReleaseStatus(ids: string, releaseStatus: number){
        return request({
            url: this.url + '/update-release-status',
            method: 'post',
            data: {
                ids: ids,
                status: releaseStatus,
            }
        })
    }

    //审核 - 规程规范
    public examine(ids: string, certStatus: number, reason: string){
        return request({
            url: this.url + '/examine-rule',
            method: 'post',
            data: {
                ids: ids,
                status: certStatus,
                reason: reason,
            }
        })
    }


    //名称是否重复
    public validateNumber(args: any){
        return request({
            url: this.url + '/validate-number',
            method: 'get',
            params: args
        })
    }
    //按照年份统计规程规范数量
    public countReleaseYear(){
        return request({
            url: this.url + '/count-release-year',
            method: 'get'
        })
    }
}

class DraftApi {
    private url: string = service + "/draft";

    public page(args: any){
        return request({
            url: this.url + '/page',
            method: 'get',
            params: args
        })
    }
    //根据code查单位
    getByCreditCode(args: any) {
        return request({
            url: this.url + '/get-by-credit-code',
            method: 'get',
            params: args
        })
    }
    update(args: any) {
        return requestJson({
            url: this.url + '/update',
            method: 'post',
            data: args
        })
    }
}

const rulesApi = new RulesApi();
const draftApi = new DraftApi();
export {rulesApi, draftApi}
